import { React, Component } from 'react';

const MTextarea = (props) => {
    const {
        name,
        label,
        placeholder,
        readOnly,
        icon,
        onClick,
        value,
        required,
        rows
    } = props;

    return (
        <textarea className='form-control' rows={rows} {...props} >
        </textarea>
    )

}
export default MTextarea;